const dustinHeaders = {
  correlationId: 'X-Correlation-ID',
  forwardedBasePath: 'X-Forwarded-BasePath',
  forwardedHost: 'X-Forwarded-Host',
  dustinForwardedHost: 'X-Dustin-Forwarded-Host',
  site: 'X-Dustin-Site',
  forwardedFor: 'X-Forwarded-For',
  sessionKey: 'X-Dustin-SessionKey',
  contactId: 'X-Dustin-ContactId',
  language: 'X-Dustin-Language',
  showPricesInclVat: 'X-Dustin-ShowPriceIncludingVat',
  anonymousUserIdentifier: 'X-Dustin-AnonymousUserIdentifier',
  forwardedProto: 'X-Forwarded-Proto',
  forwardedPort: 'X-Forwarded-Port',
  siteUrl: 'X-Site-BaseUrl',
  punchOutTicket: 'X-Dustin-PunchOutTicket',
  sessionUserIdentifier: 'X-Dustin-SessionUserIdentifier',
  dustinForwardedFor: 'X-Dustin-Forwarded-For',
  tempDustinForwardedFor: 'Dustin-X-Forwarded-For',
  personalizationConsent: 'X-Dustin-PersonalizationConsent',
}

const legacyHeaders = {
  siteBaseUrl: 'X-Site-BaseUrl',
  isMobileDevice: 'X-Is-Mobile-Device',
  siteInfoDeliveryInfoUrl: 'X-Site-DeliveryInfoUrl',
}

const productsiteHeaders = {
  pageSize: 'X-Page-Size',
  sortBy: 'X-Sort-By',
  viewType: 'X-View-Type',
}

export const cookies = {
  localOverrides: 'dustin.legacy.overrides',
  siteParams: 'dustin.standalone.siteparams',
  userParams: 'dustin.standalone.userparams',
  cookieBannerDismissed: {
    SE: {
      dismissed: 'dustin.cookie_banner_dismissed_v1',
      applied: 'dustin.cookie_consent_applied_',
    },
    NO: {
      dismissed: 'dustin.cookie_banner_dismissed_v1',
      applied: 'dustin.cookie_consent_applied_',
    },
    DK: {
      dismissed: 'dustin.cookie_banner_dismissed_v1',
      applied: 'dustin.cookie_consent_applied_',
    },
    FI: {
      dismissed: 'dustin.cookie_banner_dismissed_v1',
      applied: 'dustin.cookie_consent_applied_',
    },
    NL: {
      dismissed: 'dustin.cookie_banner_dismissed_v2',
      applied: 'dustin.cookie_consent_applied_v1',
    },
    BE: {
      dismissed: 'dustin.cookie_banner_dismissed_v2',
      applied: 'dustin.cookie_consent_applied_v1',
    },
  },
  //! Temp for enabling Cnet on NL productpages
  legacyCookiesAccepted: 'cookiepolicy-accepted',
  consent: {
    analytics: 'dustin.consent.analytics',
    marketing: 'dustin.consent.marketing',
    personalization: 'dustin.consent.personalization',
  },
  content: {
    preview: 'dustin.content.preview',
  },
  userSettings: {
    selectedContactId: 'dustin.contact_id',
    showPriceIncludingVat: 'dustin.settings.include_vat',
    lastSearchPhrase: 'dustin.settings.last-search-phrase',
    pageSize: 'dustin.settings.page-size',
    sortBy: 'dustin.settings.sort-by',
    viewType: 'dustin.settings.view-type',
    // These cookies have the same cookie name as the monolith for compatibility.
    language: 'Language',
    siteSelected: 'ssel',
    showMargins: 'showmargins',
  },
  esalesSessionKey: 'CookieSession',
  anonymousUserIdentifier: 'UserIdentifier',
  okta: {
    menuLoginInfoDismissed: 'dustin.menu_login_info_dismissed',
  },
  punchOutTicket: 'PunchOutTicket',
  sessionUserIdentifier: 'SessionUserIdentifier',
  blackFridaySignupDismissed: 'dustin.black-friday-signup-dismissed',
  menuAccountPopoverDismissed: 'dustin.menu-account-popover-dismissed',
  stickyCommitmentUspDismissed: 'dustin.sticky-commitment-usp-dismissed',
  b2cRedirect: 'dustin.b2c-redirect',
}

const errorMessages = {
  notFound: 'NOT_FOUND',
  unknown: 'UNKNOWN',
}

export const constants = {
  dustinHeaders,
  legacyHeaders,
  productsiteHeaders,
  cookies,
  errorMessages,
}
